import React from "react";
import { AssignmentPinsContext, AssignentPinsProvderValue } from "components/Assignment/AssignmentPinsProvider";
import { useContext } from "react";
import { Box } from "@mui/material";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";

const AssignmentPinsSelection = () => {
  const pinsContext = useContext<AssignentPinsProvderValue>(AssignmentPinsContext);

  // TODO: show example pins?

  return (
    <Box>
      <RadioGroup
        name="theme"
        value={pinsContext?.current?.code}
        onChange={e => pinsContext?.change(e.target.value)}>
          {pinsContext?.options?.map(t => (
            <FormControlLabel 
              key={t.code}
              value={t.code} 
              control={<Radio />} 
              label={<span>{t.name}</span>}
            />
          ))}
      </RadioGroup>
    </Box>
  );
};

export default AssignmentPinsSelection;